import * as Sentry from '@sentry/browser';

export const addNavigationBreadcrumb = (from, to) => {
  Sentry.addBreadcrumb({
    category: 'navigation',
    message: `Navigated from ${from} to ${to}`,
    level: 'info',
    data: {
      from,
      to
    }
  });
};

export const addClickBreadcrumb = (element, data = {}) => {
  Sentry.addBreadcrumb({
    category: 'ui.click',
    message: `Clicked: ${element}`,
    level: 'info',
    data: {
      element,
      ...data
    }
  });
};

export const addActionBreadcrumb = (actionType, payload = {}) => {
  Sentry.addBreadcrumb({
    category: 'redux.action',
    message: actionType,
    level: 'info',
    data: {
      type: actionType,
      payload: typeof payload === 'object' ? JSON.stringify(payload).substring(0, 100) : payload
    }
  });
};

